module.exports = __webpack_public_path__ + "static/media/productPic.73b5e764.png";